<footer class="w-100 p-3">
    <div class="container-footer col-12 col-sm-10">
        <div class="">
            <p><a routerLink="/" target="_blank">Home</a><a routerLink="/contact">Contact</a><a href="{{brandResources.loginURL}}" target="_blank">Log In</a><a routerLink="/terms" lander-checkout-partner-terms-link>Terms of
                    Service</a><a routerLink="/privacy" lander-checkout-partner-privacy-link>Privacy Policy</a></p>
        </div>
        <div class="container-logos-secured"><img loading="lazy" class="logo-financeify-footer"
                src="../../../../../assets/images/logo-financeify/icon-financeify.png" loading="lazy" priority="low"><img loading="lazy"
                class="logo-inc-v2" src="../../../../../assets/images/funnels/Inc5000-logo.png" loading="lazy" priority="low"><img loading="lazy"
                class="logo-encrypt" src="../../../../../assets/images/funnels/lets-encrypt.png" loading="lazy" priority="low">

        </div>
        <hr>
        <div class="custom-container">
            <small>© Copyrights 2024 {{ brandResources.companyTitle }}. All rights reserved.</small>
        </div>
    </div>
</footer>